import { render, staticRenderFns } from "./fccFerramentas.vue?vue&type=template&id=10687242"
import script from "./fccFerramentas.vue?vue&type=script&lang=js"
export * from "./fccFerramentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports